import { ajax as request } from '@blade/common';
/**
*@Description: 布控库人像查询
*@Date: 2020-09-01 14:39:57
*/
export const getTargets = (keywords, page, size, libId = undefined, pageOrderList) => request({
    url: '/api/portrait-management/api/v1/alert/portrait/query',
    method: 'POST',
    data: { keywords, libId, size, page, sort: 'DESC', visitorStatus: '', pageOrderList }
});
/**
*@Description: 身份库人像查询
*@Date: 2020-09-01 14:39:57
*/
export const getIdeTargets = (keywords, page, size, libId = undefined, pageOrderList) => request({
    url: '/api/portrait-management/api/v1/pass/portrait/page/query',
    method: 'POST',
    data: { keywords, libId, size, page, sort: 'DESC', visitorStatus: '', pageOrderList }
});
/**
*@Description: 添加布控人像
*@Date: 2020-09-01 14:39:57
*/
export const postTargets = (data) => request({
    url: '/api/portrait-management/api/v1/alert/portrait/create',
    method: 'POST',
    data
});
/**
*@Description: 添加身份人像
*@Date: 2020-09-01 14:39:57
*/
export const postIdeTargets = (data) => request({
    url: '/api/portrait-management/api/v1/pass/portrait/create/portrait',
    method: 'POST',
    data
});
/**
*@Description: 查询人像详情
*@Date: 2020-09-01 14:39:57
*/
export const getTargetsDetail = (targetId) => request({
    url: `/api/portrait-management/api/v1/alert/portrait/${targetId}`,
    method: 'GET'
});
/**
*@Description: 修改布控人像
*@Date: 2020-09-01 14:39:57
*/
export const putTargetsDetail = (targetId, data) => request({
    url: `/api/portrait-management/api/v1/alert/portrait/${targetId}`,
    method: 'PUT',
    data
});
/**
*@Description: 修改身份人像
*@Date: 2020-09-01 14:39:57
*/
export const putIdeTargetsDetail = (data) => request({
    url: `/api/portrait-management/api/v1/pass/portrait/update/portrait`,
    method: 'PUT',
    data
});
/**
*@Description: 删除布控库人像
*@Date: 2020-09-01 14:39:57
*/
export const deleteTargetsDetail = (targetId) => request({
    url: `/api/portrait-management/api/v1/alert/portrait/${targetId}`,
    method: 'DELETE'
});
/**
*@Description: 删除身份库人像
*@Date: 2020-09-01 14:39:57
*/
export const deleteideTargetsDetail = (targetId) => request({
    url: `/api/portrait-management/api/v1/pass/portrait/delete/portrait/${targetId}`,
    method: 'DELETE'
});
/** ==============================@Description: 人像库管理============================== */
/**
*@Description: 所有人像库查询
*@Date: 2020-09-01 14:39:57
*/
export const getlibrariesAll = (type) => request({
    url: `/api/portrait-management/portrait/library/all/${type}`,
    method: 'GET'
});
/**
*@Description: 布控库人像库查询
*@Date: 2020-09-01 14:39:57
*/
export const getlibraries = (keywords, page, size, pageOrderList) => request({
    url: '/api/portrait-management/api/v1/alert/portraitLib/query',
    method: 'POST',
    data: { keywords, size, page, pageOrderList }
});
/**
*@Description: 身份库人像库查询
*@Date: 2020-09-01 14:39:57
*/
export const getIdenlibraries = (keywords, page, size, pageOrderList) => request({
    url: '/api/portrait-management/api/v1/pass/portraitLib/query',
    method: 'POST',
    data: { keywords, size, page, pageOrderList }
});
/**
*@Description: 添加布控人像库
*@Date: 2020-09-01 14:39:57
*/
export const postlibraries = (data) => request({
    url: '/api/portrait-management/api/v1/alert/portraitLib/add',
    method: 'POST',
    data
});
/**
*@Description: 添加身份人像库
*@Date: 2020-09-01 14:39:57
*/
export const postIdelibraries = (data) => request({
    url: '/api/portrait-management/api/v1/pass/portraitLib/create',
    method: 'POST',
    data
});
/**
*@Description: 查询布控人像库详情
*@Date: 2020-09-01 14:39:57
*/
export const getlibrariesDetail = (libraryId) => request({
    url: `/api/portrait-management/api/v1/alert/portraitLib/${libraryId}`,
    method: 'GET'
});
/**
*@Description: 查询身份人像库详情
*@Date: 2020-09-01 14:39:57
*/
export const getIdelibrariesDetail = (libraryId) => request({
    url: `/api/portrait-management/api/v1/pass/portrait/detail/${libraryId}`,
    method: 'GET'
});
/**
*@Description: 修改布控人像库
*@Date: 2020-09-01 14:39:57
*/
export const putlibrariesDetail = (libId, data) => request({
    url: `/api/portrait-management/api/v1/alert/portraitLib/${libId}`,
    method: 'PUT',
    data
});
/**
*@Description: 修改身份人像库
*@Date: 2020-09-01 14:39:57
*/
export const putIdelibrariesDetail = (libId, data) => request({
    url: `/api/portrait-management/api/v1/pass/portraitLib/${libId}`,
    method: 'PUT',
    data
});
/**
*@Description: 删除布控人像库
*@Date: 2020-09-01 14:39:57
*/
export const deletelibrariesDetail = (libraryId) => request({
    url: `/api/portrait-management/api/v1/alert/portraitLib/${libraryId}`,
    method: 'DELETE'
});
/**
*@Description: 删除身份人像库
*@Date: 2020-09-01 14:39:57
*/
export const deleteIdelibrariesDetail = (libraryId) => request({
    url: `/api/portrait-management/api/v1/pass/portraitLib/${libraryId}`,
    method: 'DELETE'
});
/**
*@Description: 启用布控人像库
*@Date: 2020-09-01 14:39:57
*/
export const activelibraries = (libraryId) => request({
    url: `/api/portrait-management/api/v1/alert/portraitLib/enable/${libraryId}`,
    method: 'PUT'
});
/**
*@Description: 停用布控人像库
*@Date: 2020-09-01 14:39:57
*/
export const offlinelibraries = (libraryId) => request({
    url: `/api/portrait-management/api/v1/alert/portraitLib/disable/${libraryId}`,
    method: 'PUT'
});
/**
*@Description: 启用身份人像库
*@Date: 2020-09-01 14:39:57
*/
export const activeIdelibraries = (libraryId) => request({
    url: `/api/portrait-management/api/v1/pass/portrait/enable/${libraryId}`,
    method: 'PUT'
});
/**
*@Description: 停用身份人像库
*@Date: 2020-09-01 14:39:57
*/
export const offIdelinelibraries = (libraryId) => request({
    url: `/api/portrait-management/api/v1/pass/portrait/disable/${libraryId}`,
    method: 'PUT'
});
// 批量删除
export const batchDelete = (data) => request({
    url: `/api/portrait-management/portrait/batch/delete`,
    method: 'POST',
    data
});
// 批量编辑
export const batchEdit = (data) => request({
    url: `/api/portrait-management/portrait/batch/update`,
    method: 'PUT',
    data
});
